import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import ChartSaleHorizontalBar from './ChartSaleHorizontalBar';

const EmployeesSalesCharts = ({ data = {}, topN = 20, currency = '' }) => {
  const { t } = useTranslation();
  const {
    employeesByAmount = { labels: [], values: [] },
    employeesByCount = { labels: [], values: [] }
  } = data || {};

  const slice = (arr) => (Array.isArray(arr) ? arr.slice(0, topN) : []);

  const amountLabelsForChart   = slice(employeesByAmount.labels).map(emp => ({
    fullName: emp.fullName || `${emp.surname || ''} ${emp.name || ''}`.trim(),
    role: t('salesStatistics.Seller')
  }));
  const amountValues = slice(employeesByAmount.values);

  const countLabelsForChart = slice(employeesByCount.labels).map(emp => ({
    fullName: emp.fullName || `${emp.surname || ''} ${emp.name || ''}`.trim(),
    role: t('salesStatistics.Seller')
  }));
  const countValues = slice(employeesByCount.values);

  const noData = !amountValues.length && !countValues.length;
  if (noData) {
    return (
      <div className="p-3 bg-white">
        <h5>{t('statistic.noData')}</h5>
      </div>
    );
  }

  return (
    <Row className="gy-4">
      <Col md={6} className='ps-md-0'>
        <h4 className="fs-3 text-dark mb-4 pb-2">{t('salesStatistics.By cost of goods sold')}</h4>
        <ChartSaleHorizontalBar
          label={t('salesStatistics.By cost of goods sold')}
          labels={amountLabelsForChart }
          dataCounts={amountValues}
          color="#EEECF8"
          borderColor="#5842BE"
          currency={currency}
          tooltipLabel='salesStatistics.Product cost'
          role
        />
      </Col>
      <Col md={6} className='pe-md-0'>
        <h4 className="fs-3 text-dark mb-4 pb-2">{t('salesStatistics.By quantity of goods sold')}</h4>
        <ChartSaleHorizontalBar
          label={t('salesStatistics.By quantity of goods sold')}
          labels={countLabelsForChart}
          dataCounts={countValues}
          color="#E8F7F4"
          borderColor="#1AB394"
          tooltipLabel='salesStatistics.Number of products sold'
          role
        />
      </Col>
    </Row>);
};

export default EmployeesSalesCharts;